import { AdminApi } from './';

const {REACT_APP_API_BASE_URL, REACT_APP_API_VERSION} = process.env;

export class UserApi {
    static getAllUsers () {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/users`, {
            ...AdminApi.GetDefualtMethod
        });
    }

    static getAccountAccess (data) {
        return fetch(`${process.env.REACT_APP_API_BASE_URL}/userAccountAccess`, {
            ...AdminApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/user.js